import { ADD_MODEL, DELETE_MODEL, GET_MODEL, UPDATE_MODEL , GET_ONE_MODEL } from "../types";
  
  const initialState = { list: [], single: null };
  
  const reducer = (state = initialState, action) => {
    const { type, payload } = action;
  
    switch (type) {
      case GET_MODEL:
        return { ...state, list: payload };
  
      case UPDATE_MODEL:
        return {
          ...state,
          list: state.list.map((item) =>
            item.id === payload.id ? payload : item
          ),
        };
  
      case ADD_MODEL:
        return {
          ...state,
          list: [payload, ...state.list],
        };
  
      case DELETE_MODEL:
        return {
          ...state,
          list: state.list.filter((item) => item.id !== payload.id),
        };

      case GET_ONE_MODEL:
        return { ...state, single: payload };
  
      default:
        return state;
    }
  };
  
  export default reducer;
  